import React from 'react';
import Label from '../ui/forms/Label';
import BoxedNumberInput from '../shared/forms/BoxedNumberInput';
import BoxedInput from '../shared/forms/BoxedInput';
import DoubleWrap from '../ui/forms/DoubleWrap';
import InputWrap from '../ui/forms/InputWrap';
import FormTextWrap from '../ui/forms/FormTextWrap';
import Button from '../ui/Button';
import FormWrapper from '../ui/forms/FormWrapper';
import ButtonWrap from '../ui/forms/ButtonWrap';
import BackButton from '../ui/BackButton';
import FileButton from '../ui/forms/file/FileButton';
import FileUpload from '../ui/forms/file/FileUpload';
import FileClose from '../ui/forms/file/FileClose';
import FileLabelWrapper from '../ui/forms/file/FileLabelWrapper';
import File from '../ui/forms/file/File';
import CPFTitle from '../ui/forms/CPFTitle';
import CPFBody from '../ui/forms/CPFBody';
import CPFColumn from '../ui/forms/CPFColumn';
import * as utilities from '../../store/utility';
import NumberFormat from 'react-number-format';

const OccupationDetails = (props) => {

        const
        {
            state,
            applicantDetails,
            myInfoMode,
            errorSubmitApplication
        } = props;

        return (
            <>
                <div data-test-id = 'occupationDetails'>
                    <FormTextWrap>
                        Please verify and update your information.
                    </FormTextWrap>
                    <FormWrapper>
                        <DoubleWrap>
                            <BoxedInput
                                disabled={applicantDetails.employment.employer.source === '1'}
                                maxLength="124"
                                type="text"
                                onChange={props.onChange}
                                label="Employer"
                                name="stage6_employer"
                                value={state.stage6_employer}
                                error={state.stage6_employer_error} />
                            <BoxedInput
                                disabled={applicantDetails.employment.occupation.source === '1'}
                                type="text"
                                maxLength="100"
                                onChange={props.onChange}
                                label="Occupation"
                                name="stage6_occupation"
                                value={state.stage6_occupation}
                                error={state.stage6_occupation_error}/>
                        </DoubleWrap>
                        <DoubleWrap>
                            <BoxedNumberInput
                                disabled={applicantDetails.employment.assessibleIncome.source === '1'}
                                type="text"
                                decimalScale={2}
                                thousandSeparator={true}
                                fixedDecimalScale={true}
                                value={state.stage6_assessableIncome}
                                onChange={props.onChange}
                                label="Assessable Income"
                                prefix="SGD"
                                name="stage6_assessableIncome"
                                error={state.stage6_assessableIncome_error}/>
                            <BoxedNumberInput
                                disabled={applicantDetails.employment.assessmentYear.source === '1'}
                                type="tel"
                                value={state.stage6_yearOfNotice}
                                maxLength="4"
                                decimalSeparator={false}
                                onChange={props.onChange}
                                label="Year of Notice of Assessment"
                                name="stage6_yearOfNotice"
                                error={state.stage6_yearOfNotice_error} />
                        </DoubleWrap>
                        {
                            !myInfoMode ?
                                <InputWrap>

                                    <Label>Upload Supporting Document <br />
                            (Latest Notice of Assessment (NOA) or Latest 3 Months Payslips)</Label>
                                    {
                                        state.stage6_files.map((i, idx) =>
                                            <File key={idx}>
                                                <FileLabelWrapper>{i.name}</FileLabelWrapper>
                                                <FileClose onClick={() => props.onFileRemove('stage6_fileClose', i)}><span>✕</span></FileClose>

                                            </File>)
                                    }
                                    {state.stage6_files.length < 5 &&
                                        <FileButton isMultiple={state.stage6_files.length > 0}>
                                            Upload File
                                            <FileUpload
                                                name="stage6_fileupload"
                                                type="file"
                                                onChange={props.onFileUpload}
                                                accept="image/x-png,image/gif, image/jpeg, image/jpg, image/tif, image/tiff, image/bmp, application/pdf"
                                                multiple />
                                        </FileButton>
                                    }
                                    <Label isValidationMsg >{state.stage6_file_error}</Label>
                                </InputWrap> :
                                <div>
                                    {
                                        typeof state.stage6_contribution !== 'undefined' && state.stage6_contribution.length > 0
                                        &&
                                        <InputWrap>
                                            <div>
                                                <Label>Employer CPF Contribution</Label>
                                                <CPFTitle>
                                                    <CPFColumn className="cpf_month">For Month</CPFColumn>
                                                    <CPFColumn className="cpf_paid">Paid On</CPFColumn>
                                                    <CPFColumn className="cpf_amount">Amount (S$)</CPFColumn>
                                                    <CPFColumn className="cpf_contribution">Employer</CPFColumn>
                                                </CPFTitle>
                                                <div className="cpfbody_wrap">
                                                    {
                                                        state.stage6_contribution.map((i, idx) =>
                                                            <CPFBody key={idx}>
                                                                <CPFColumn className="cpf_month">{i.contributionMonth}</CPFColumn>
                                                                <CPFColumn className="cpf_paid">
                                                                    {utilities.formatToddMMyyyy(i.contributionDate)}
                                                                </CPFColumn>
                                                                <CPFColumn className="cpf_amount">
                                                                    <NumberFormat
                                                                        value={i.amount}
                                                                        decimalScale={2}
                                                                        displayType={'text'}
                                                                        fixedDecimalScale={true}
                                                                        thousandSeparator={true} />
                                                                </CPFColumn>
                                                                <CPFColumn className="cpf_contribution">{i.employer}</CPFColumn>
                                                            </CPFBody>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </InputWrap>
                                    }
                                </div>
                        }
                        {
                            !myInfoMode &&
                            <InputWrap>
                                <Label>Other Supporting Documents</Label>
                                {
                                    state.stage6_files_others.map((i, idx) =>
                                        <File key={idx}>
                                            <FileLabelWrapper>{i.name}</FileLabelWrapper>
                                            <FileClose onClick={() => props.onFileRemove('stage6_fileClose_others', i)}><span>✕</span></FileClose>
                                        </File>)
                                }
                                {state.stage6_files_others.length < 3 &&
                                    <FileButton isMultiple={state.stage6_files_others.length > 0}>
                                        Upload File
                                        <FileUpload
                                            name="stage6_fileupload_others"
                                            type="file"
                                            onChange={props.onFileUpload}
                                            accept="image/x-png,image/gif, image/jpeg, image/jpg, image/tif, image/tiff, image/bmp, application/pdf"
                                            multiple />
                                    </FileButton>
                                }
                            </InputWrap>
                        }

                    </FormWrapper>
                    <ButtonWrap>
                        <BackButton onClick={() => props.onBackContact()}>
                            Back
                        </BackButton>
                        <Button onClick={() => props.onVerifyOccupation()}>
                            Next
                    </Button>
                    </ButtonWrap>
                    {
                        errorSubmitApplication &&
                        <Label isError name="nricvaliderror">
                            {errorSubmitApplication}
                        </Label>
                    }
                </div>
            </>
        );
    };

export default OccupationDetails;
